import {Button, List, Modal} from "antd";
import {Narrator} from "../../../feature/project/Shot";
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import React, {useEffect} from "react";
import {fetchNarrators} from "../../../feature/project/projectsSlice";
import {useParams} from "react-router-dom";
import {NarratorManagerItem} from "./NarratorManagerItem";


export const NarratorManagerDialog = (props: {
    onNarratorSelected: (narrator: Narrator) => void,
    onCancel: () => void
}) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const [newNarrator, setNewNarrator] = React.useState<Narrator>({title: '', color: ''} as Narrator)
    const narrators = useAppSelector(state => [...state.projects.narrators, newNarrator])
    const status = useAppSelector(state => state.narrations.status)

    useEffect(() => {
        if (projectId) {
            dispatch(fetchNarrators({projectId: parseInt(projectId)}))
        }
    }, [projectId, status]);

    return (
        <>
            <Modal
                open={true}
                title={'Select Narrator'}
                footer={
                    <Button onClick={props.onCancel}>Close</Button>
                }
            >
                <List
                    bordered
                    dataSource={narrators}
                    renderItem={(item: Narrator, index: number) => (
                        <NarratorManagerItem
                            key = {index}
                            narrator={item}
                            onNarratorSelected={props.onNarratorSelected}
                        />
                    )}
                />
            </Modal>
        </>
    )
}